import idb from 'idb'

export default function dbPromise () {
  const dbPromise = idb.open('dms-db', 1, upgradeDb => {
    switch (upgradeDb.oldVersion) {
      case 0:
        upgradeDb.createObjectStore('outbox-timesheets', {autoIncrement: true})
        upgradeDb.createObjectStore('outbox-receipts')
        upgradeDb.createObjectStore('timesheet-archive')
        upgradeDb.createObjectStore('image-store')
        upgradeDb.createObjectStore('current-expenses')
    }
  })

  return dbPromise
}



// WEBPACK FOOTER //
// ./src/dbPromise.js